import { useGetData, useToggleStatusMutation } from "@/services";
import { MasterModuleLayout, useMasterModule } from "../Common";

const PropertyZone = () => {
  const masterHook = useMasterModule({
    queryKey: "property-zones",
    idKey: "zoneId",
    nameKey: "zoneName",
    useGetDataQuery: useGetData,
    useToggleStatusMutation: useToggleStatusMutation,
    module: "property-zones",
    statusSuccessMessage: "Property Zones Status Updated Successfully",
  });

  return <MasterModuleLayout title="Property Zones" hookResult={masterHook} />;
};

export default PropertyZone;
